import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import {
  Link
} from 'react-router-dom'
import gameContract from '../data/gameContract.js';
import chars from '../data/chars';
import {
    CONTRACT_ADDRESS_256,
    CONTRACT_ADDRESS_64,
    ETHERSCAN_BASE,
    GAME_IDS,
    MAX_TILES_256,
    MAX_TILES_64,
    SIDE_LENGTH_16,
    SIDE_LENGTH_8,
    ZERO_X,
} from '../constants.js';
import Tiles from './Tiles.js';
import GameInfo from './GameInfo';
import GameModeToggle from './GameModeToggle';
import EthPrice from './EthPrice';
import ClaimButton from './ClaimButton';
import GameNumber from './GameNumber';
import Footer from './Footer';
import MyHero from './MyHero';
import MaintenancePage from './MaintenancePage';
import SocialButtons from './SocialButtons';
import WinPage from './WinPage';
import './App.css';
import './Notification.css';
import MetamaskLink from './MetamaskLink';
import WelcomeNotification from './WelcomeNotification';


export default class GamePage extends Component {
    constructor(props) {
        super(props);

        let currGameId = SIDE_LENGTH_8
        if (props.match && props.match.params) {
            const { gameId } = props.match.params;
            if (GAME_IDS.includes(gameId)) {
                currGameId = gameId;
            }
        }

        this.state = {
            currentAddress: null,
            gamesById: {
                [SIDE_LENGTH_16]: {
                    tiles: Array(SIDE_LENGTH_16).fill().map(x => Array(SIDE_LENGTH_16).fill({
                        address: ZERO_X,
                        isClaimed: false,
                        isLoading: false,
                    })),
                    gameCost: null,
                    gameNumber: null,
                    gameWon: false,
                    winningAddress: null,
                    hasWinnings: false,
                    sideLength: SIDE_LENGTH_16,
                    contractAddress: CONTRACT_ADDRESS_256,
                    maxTiles: MAX_TILES_256,

                },
                [SIDE_LENGTH_8]: {
                    tiles: Array(SIDE_LENGTH_8).fill().map(x => Array(SIDE_LENGTH_8).fill({
                        address: ZERO_X,
                        isClaimed: false,
                        isLoading: false,
                    })),
                    gameCost: null,
                    gameNumber: null,
                    gameWon: false,
                    winningAddress: null,
                    hasWinnings: false,
                    sideLength: SIDE_LENGTH_8,
                    contractAddress: CONTRACT_ADDRESS_64,
                    maxTiles: MAX_TILES_64,
                },
            },
            isFetching: true,
            errorFetching: false,
            isUnderMaintenance: false,
            currGameId,
        }
    }

    componentDidMount() {
        if (this.props.web3) {
            Object.keys(this.state.gamesById).forEach((gameId) => {
                this.setup(this.props.web3, gameId);
            });
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.web3 && !this.props.web3) {
            Object.keys(this.state.gamesById).forEach((gameId) => {
                this.setup(newProps.web3, gameId);
            });
        }
        const { match } = newProps;
        if (match && match.params && match.params.gameId !== this.state.currGameId) {
            const { gameId: currGameId } = newProps.match.params;
            this.setState(() => ({
                currGameId
            }));;
        }
    }

    setup = (web3, gameId) => {
        const { contractAddress } = this.state.gamesById[gameId];
        const contract = web3.eth.contract(gameContract.abi).at(contractAddress);

        this.processMetamask(web3).then((currentAddress) => {
            this.checkWinnings(contract, currentAddress, gameId);
        }).catch(console.error);

        this.getGameNum(contract, gameId).then((gameNumber) => {
            this.getTiles(contract, gameNumber, gameId);
            this.getGamePrice(contract, gameId);
            // todo: add getNextGamePrice
            this.watchTileClaimedEvent(contract, gameNumber, gameId);
            this.watchWinEvent(contract, gameNumber, gameId);
        }).catch(console.error);
    }

    processMetamask = (web3) => {
        return new Promise((resolve, reject) => {
            const accounts = web3.eth.accounts;
            const currentAddress = (accounts && accounts.length > 0) ? accounts[0] : '';

            if (currentAddress) {
                resolve(currentAddress);

                this.setState({
                    currentAddress
                });
            } else {
                reject(new Error('could not find an address.'));
            }
        });
    }

    checkWinnings = (contract, currentAddress, gameId) => {
        contract.pendingWithdrawals(currentAddress, (err, res) => {
            if (err) {
                //todo: error state
            }

            if (res && res.toNumber()) {
                this.setState((state, props) => ({
                    gamesById: {
                        ...state.gamesById,
                        [gameId]: {
                            ...state.gamesById[gameId],
                            hasWinnings: true,
                        }
                    }
                }));
            }
        });
    }

    getGameNum = (contract, gameId) => {
        return new Promise((resolve, reject) => {
            contract.currentGameNumber.call((err, res) => {
                if (err) {
                    reject(err);
                }
                const gameNumber = res.toNumber();
                resolve(gameNumber);

                this.setState((state, props) => ({
                    gamesById: {
                        ...state.gamesById,
                        [gameId]: {
                            ...state.gamesById[gameId],
                            gameNumber,
                        }
                    }
                }));
            });
        });
    }

    getGamePrice = (contract, gameId) => {
        return new Promise((resolve, reject) => {
            contract.currentGameCost.call((err, res) => {
                if (err) {
                    reject(err);
                }
                const gameCost = res.toNumber();
                resolve(gameCost);

                this.setState((state, props) => ({
                    gamesById: {
                        ...state.gamesById,
                        [gameId]: {
                            ...state.gamesById[gameId],
                            gameCost,
                        }
                    }
                }));
            });
        });
    }

    getTiles = (contract, gameNumber, gameId) => {
        this.setState({
            isFetching: true,
            errorFetching: false,
        });

        const { maxTiles, sideLength } = this.state.gamesById[gameId];

        const asyncTiles = Array(sideLength).fill().map(x => Array(sideLength).fill());

        let numTilesFetched = 0;

        for (let i = 0; i < sideLength; i++) {
            for (let j = 0; j < sideLength; j++) {
                contract.tiles(i, j, (err, result) => {
                    if (err) {
                        this.setState({
                            isFetching: false,
                            errorFetching: true,
                        });
                        this.showWarningMessage('Error fetching the latest tile data');
                        return;
                    }

                    numTilesFetched++;

                    if (result && result[0] != null) {
                        const lastGameOpened = result[0].toNumber();
                        const isClaimed = (lastGameOpened === gameNumber);
                        const address = isClaimed ? result[1].toString() : ZERO_X;
                        asyncTiles[i][j] = {
                            address,
                            isClaimed,
                        };
                    }

                    const isDoneFetching = numTilesFetched === maxTiles;
                    if (isDoneFetching) {
                        const areAllTilesFetched = this.checkAllTilesFetched(asyncTiles);

                        if (areAllTilesFetched) {
                            this.setState((state, props) => ({
                                gamesById: {
                                    ...state.gamesById,
                                    [gameId]: {
                                        ...state.gamesById[gameId],
                                        tiles: asyncTiles,
                                    }
                                },
                                isFetching: false,
                                errorFetching: false,
                            }));
                        } else {
                            // todo: add error fetching tolerance here
                            this.setState({
                                isFetching: false,
                                errorFetching: true,
                            });
                        }
                    }
                });
            }
        }
    }

    watchWinEvent = (contract, gameNumber, gameId) => {
        const winEvent = contract.GameWon({ gameNumber });
        winEvent.watch((err, res) => {
            if (err) {
                return new Error(err);
            }
            this.setState((state, props) => ({
                gamesById: {
                    ...state.gamesById,
                    [gameId]: {
                        ...state.gamesById[gameId],
                        winningAddress: res.args.winner,
                        gameWon: true,
                    },
                },
            }));
        });
    }

    watchTileClaimedEvent = (contract, gameNumber, gameId) => {
        const tileClaimed = contract.TileClaimed({ gameNumber });
        tileClaimed.watch((err, res) => {
            if (err) {
                return new Error(err);
            }
            if (res.args.xCoord && res.args.yCoord && res.args.claimedBy) {
                const tileProps = {
                    address: res.args.claimedBy,
                    isClaimed: true,
                    isLoading: false,
                };
                this.updateTile(
                    res.args.xCoord.toNumber(),
                    res.args.yCoord.toNumber(),
                    tileProps,
                    gameId
                );
            }
        });
    }

    checkAllTilesFetched = (tiles) => {
        const { sideLength } = this.state;
        for (let i = 0; i < sideLength; i++) {
            for (let j = 0; j < sideLength; j++) {
                if (tiles[i][j] === undefined) {
                    return false;
                }
            }
        }

        return true;
    }

    checkTile = (xCoord, yCoord) => { // todo: change function signature
        const { currGameId } = this.state;
        const currGame = this.state.gamesById[currGameId];
        if (!this.state.currentAddress) {
            this.showWarningMessage("No addresses available", "Please unlock an account using MetaMask.");
            return;
        }

        const { contractAddress } = this.state.gamesById[currGameId];

        const web3 = this.props.web3;
        const contract = web3.eth.contract(gameContract.abi).at(contractAddress);
        const data = contract.claimTile.getData(xCoord, yCoord, currGame.gameNumber);

        this.showStartNotification(xCoord, yCoord);

        web3.eth.sendTransaction({
            to: contractAddress,
            from: this.state.currentAddress,
            value: currGame.gameCost,
            data: data
        }, (err, transactionId) => {
            this.dismissNotification('startNotification');

            if (!err) {
                this.updateTile(xCoord, yCoord, { isLoading: true }, currGameId);
                this.showTransactionNotification(web3, xCoord, yCoord, transactionId);
            }
        });
    }

    claimWinnings = () => {
        const currGame = this.state.gamesById[this.state.currGameId];
        const { contractAddress } = currGame;
        const contract = this.props.web3.eth.contract(gameContract.abi).at(contractAddress);
        let data = contract.claimWinnings.getData();

         this.props.web3.eth.sendTransaction({
            to: contractAddress,
            from: this.state.currentAddress,
            data: data
        }, (err, transactionId) => {
            if (!err) {
                this.showClaimNotification(this.props.web3, transactionId);
            }
        });
    }

    showMetamaskNotification = () => {
      let notificationSystem = this.refs.notificationSystem;
      if (window.event && window.event.preventDefault) {
          window.event.preventDefault();
      }

      let notification = notificationSystem.addNotification({
          message: `
            This game must be played on a computer with the MetaMask extension for Chrome.
          `,
          level: 'info',
          autoDismiss: 0,
          children: (
              <MetamaskLink />
          )
      });

      this.setState({
          metamaskNotification: notification,
      });
    }

    showStartNotification = (xCoord, yCoord) => {
        let notificationSystem = this.refs.notificationSystem;
        if (window.event && window.event.preventDefault) {
            window.event.preventDefault();
        }

        let notification = notificationSystem.addNotification({
            message: `You're about to claim a tile!`,
            level: 'info',
            autoDismiss: 0,
            children: (
                <h3 className="notification-text">Please click "Submit" in MetaMask.</h3>
            )
        });

        this.setState({
            startNotification: notification
        })
    }

    showTransactionNotification = (web3, xCoord, yCoord, transactionId) => {
        let notificationSystem = this.refs.notificationSystem;
        let explorerUrl = `https://${ETHERSCAN_BASE}/tx/` + transactionId;

        let notification = notificationSystem.addNotification({
            level: 'info',
            message: `Claiming tile for ending: "${chars[xCoord]}${chars[yCoord]}"`,
            children: (
                <div>
                    <p className="notification-text">Please wait...</p>
                    <p className="notification-text bold">Transaction: </p>
                    <a className="notification-link" target="_new" href={explorerUrl}>{transactionId}</a>
                </div>
            ),
            autoDismiss: 0
        });

        this.setState({
            transactionNotification: notification
        })
    }

    showClaimNotification = (web3, transactionId) => {
        let notificationSystem = this.refs.notificationSystem;
        let explorerUrl = `https://${ETHERSCAN_BASE}/tx/` + transactionId;

        let notification = notificationSystem.addNotification({
            level: 'info',
            message: 'Claiming winnings...',
            children: (
                <div>
                    <p className="notification-text bold">Transaction:</p>
                    <a className="notification-link" target="_new" href={explorerUrl}>{transactionId}</a>
                </div>
            ),
            autoDismiss: 0
        });

        this.setState({
            claimNotification: notification
        });
    }

    dismissNotification = (notificationName) => {
        let notificationSystem = this.refs.notificationSystem;

        if (this.state[notificationName]) {
            notificationSystem.removeNotification(this.state[notificationName]);
            this.setState({
                [notificationName]: null
            });
        }
    }

    updateTile = (xCoord, yCoord, props, gameId) => {
        this.setState((state) => {
            const newTiles = state.gamesById[gameId].tiles.map(row => row.slice());
            newTiles[xCoord][yCoord] = {
                ...newTiles[xCoord][yCoord],
                ...props,
            };

            return {
                gamesById: {
                    ...state.gamesById,
                    [gameId]: {
                        ...state.gamesById[gameId],
                        tiles: newTiles,
                    }
                },
            };
        });
    }

    processTransactionResult = (web3, xCoord, yCoord, transaction) => {
        //TODO: why was this a todo before? I thought this was working...
        const tileProps = {
            address: this.state.currentAddress,
            isClaimed: true,
            isLoading: false,
        };
        this.updateTile(xCoord, yCoord, tileProps);
    }

    showWarningMessage = (message, secondaryMessage="Please refresh the page.") => {
        let notificationSystem = this.refs.notificationSystem;

        let notification = notificationSystem.addNotification({
            level: 'warning',
            message: message,
            children: (
                <div>
                    <h3 className='notification-text'> {secondaryMessage} </h3>
                </div>
            ),
            autoDismiss: 5
        });

        this.setState({
            warningNotification: notification
        });
    }

    getGameCostInEth = (gameCost) => {
        const { web3 } = this.props;

        if (!web3 || !gameCost) {
            return null;
        }

        return web3.fromWei(gameCost)
    }

    render() {
        const {
            currGameId,
            currentAddress,
            errorFetching,
            isFetching,
            isUnderMaintenance
        } = this.state;
        const currGame = this.state.gamesById[currGameId];
        const {
            gameCost,
            gameNumber,
            gameWon,
            hasWinnings,
            tiles,
            winningAddress,
            sideLength,
            maxTiles
        } = currGame;

        if (gameWon) {
            return <WinPage
                    currentAddress={currentAddress}
                    winningAddress={winningAddress}
                    gameId={currGameId}
                    gameNumber={gameNumber}
                    claimWinnings={this.claimWinnings} />;
        } else if (isUnderMaintenance) {
            return <MaintenancePage />;
        } else {
            return (
                <div className="big-container">
                    <div className="container">
                        <WelcomeNotification />
                        <NotificationSystem ref="notificationSystem" />
                        { currentAddress && <MyHero seed={currentAddress} /> }
                        <div className="header-bar">
                            <h1 className="game-title"> Hash Heroes </h1>
                            <Link className="hash-link" to="/winners">See all winners</Link>
                        </div>
                        <GameInfo gameCost={this.props.web3 && this.props.web3.fromWei(gameCost)} maxTiles={maxTiles}/>
                        {hasWinnings && <ClaimButton claimWinnings={this.claimWinnings} />}
                        <GameModeToggle currentGameId={sideLength}/>
                        <div className="readout-container">
                            <EthPrice
                                gameCost={this.getGameCostInEth(gameCost)}
                                isFetching={isFetching}
                                errorFetching={errorFetching}
                            />
                            <GameNumber gameNumber={gameNumber} />
                        </div>
                        <Tiles
                            tiles={tiles}
                            checkFunction={this.checkTile}
                            currentAddress={currentAddress}
                            showNotification={this.showMetamaskNotification}
                            isDisabled={false}
                        />
                    </div>
                    <SocialButtons />
                    <Footer />
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/GamePage.js